import { defineComponent } from 'vue';
import { QCard, QCardSection, QIcon, QMenu } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';

import TranslationContainer from './TranslationContainer.jsx';

import utils from '../../Shared/utils.jsx';

/**
 * Not Implemented:
 *  *RoundCards
 *  *ShadowColor
 */

const CardListItem = defineComponent({
    name: 'card-list-item',
    mixins: [BaseComponent],
    emits: ['selected', 'click'],
    components: {
        TranslationContainer,
        QCard,
        QCardSection,
        QIcon
    },
    props: {
        sourceData: null,
        listCardTemplate: {},
        initialSelectedCardEval: null,
        selectCardOnClick: false,
        clickActions: null
    },
    data() {
        return {
            labelEval: null,
            middlePayloadEval: null,
            rightPayloadEval: null,
            colorEval: null,
            cssClassEval: null,
            leftIconEval: null,
            rightIconEval: null,
            listHeightUnitEval: null,
            listHeightEval: null,
            paddingEval: null,
            lineHeightEval: null,
            roundCardsEval: null,
            hoverColorEval: null,
            shadowColorEval: null,
            hovering: false
        }
    },
    mounted() {
        if(this.initialSelectedCardEval && utils.evaluate(this.initialSelectedCardEval, this))
            this.$emit('selected');

        this.renderComplete();
    },
    computed: {
        label() {
            try {
                if(this.labelEval === null && this.listCardTemplate.Label)
                    this.labelEval = utils.compile(this, this.listCardTemplate.Label);
                if(this.labelEval)
                    return utils.evaluate(this.labelEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Label could not evaluate expression: ' + this.listCardTemplate.Label + '; ' + e);
                return '';
            }
        },
        middlePayload() {
            if(this.listCardTemplate.MiddlePayload)
                return this.listCardTemplate.MiddlePayload;
            return '';
        },
        rightPayload() {
            if(this.listCardTemplate.RightPayload)
                return this.listCardTemplate.RightPayload;
            return '';
        },
        color() {
            try {
                if(this.colorEval === null && this.listCardTemplate.Color)
                    this.colorEval = utils.compile(this, this.listCardTemplate.Color);
                if(this.colorEval)
                    return utils.evaluate(this.colorEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Color could not evaluate expression: ' + this.listCardTemplate.Color + '; ' + e);
                return '';
            }
        },
        cssClass() {
            try {
                if(this.cssClassEval === null && this.listCardTemplate.CssClass)
                    this.cssClassEval = utils.compile(this, this.listCardTemplate.CssClass);
                if(this.cssClassEval)
                    return utils.evaluate(this.cssClassEval, this);
                return '';
            }
            catch (e) {
                utils.warn('CssClass could not evaluate expression: ' + this.listCardTemplate.CssClass + '; ' + e);
                return '';
            }
        },
        leftIcon() {
            try {
                if(this.leftIconEval === null && this.listCardTemplate.LeftIcon)
                    this.leftIconEval = utils.compile(this, this.listCardTemplate.LeftIcon);
                if(this.leftIconEval)
                    return utils.evaluate(this.leftIconEval, this);
                return '';
            }
            catch (e) {
                utils.warn('LeftIcon could not evaluate expression: ' + this.listCardTemplate.LeftIcon + '; ' + e);
                return '';
            }
        },
        rightIcon() {
            try {
                if(this.rightIconEval === null && this.listCardTemplate.RightIcon)
                    this.rightIconEval = utils.compile(this, this.listCardTemplate.RightIcon);
                if(this.rightIconEval)
                    return utils.evaluate(this.rightIconEval, this);
                return '';
            }
            catch (e) {
                utils.warn('RightIcon could not evaluate expression: ' + this.listCardTemplate.RightIcon + '; ' + e);
                return '';
            }
        },
        padding() {
            try {
                if(this.paddingEval === null && this.listCardTemplate.Padding)
                    this.paddingEval = utils.compile(this, this.listCardTemplate.Padding);
                if(this.paddingEval)
                    return utils.evaluate(this.paddingEval, this);
                return 0;
            }
            catch (e) {
                utils.warn('Padding could not evaluate expression: ' + this.listCardTemplate.Padding + '; ' + e);
                return 0;
            }
        },
        hoverColor() {
            try {
                if(this.hoverColorEval === null && this.listCardTemplate.HoverColor)
                    this.hoverColorEval = utils.compile(this, this.listCardTemplate.HoverColor);
                if(this.hoverColorEval)
                    return utils.evaluate(this.hoverColorEval, this);
                return '';
            }
            catch (e) {
                utils.warn('HoverColor could not evaluate expression: ' + this.listCardTemplate.HoverColor + '; ' + e);
                return '';
            }
        },
        activeColor() {
            return this.hovering ? this.hoverColor : this.color;
        },
        activeColorClass() {
            const color = this.activeColor;
            if (!color || !/^[a-zA-Z0-9_-]+$/.test(color))
                return '';
            return `bg-${color}`;
        },
        activeColorStyle() {
            return {
                backgroundColor: this.activeColor
            };
        }
    },
    methods: {
        mouseEnter() {
            this.hovering = true;
        },
        mouseLeave() {
            this.hovering = false;
        },
        async onClick(e) {
            if(this.selectCardOnClick)
                this.$emit('selected');

            if(this.clickActions)
                utils.executeAndCompileAllActions(this.clickActions, {Value: this.sourceData}, this);  
            
            this.$emit('click', e);
        }
    },
    render() {
        let content = [];
        if(this.label)
            content.push((
                <QCardSection class="text-h6 q-pb-none">
                    {this.label}
                </QCardSection>
            ));
        
        if(this.middlePayload || this.rightPayload || this.leftIcon || this.rightIcon) {
            let cardTextContent = [];

            if(this.leftIcon)
                cardTextContent.push((
                    <QIcon class="q-mr-sm" size="16px">
                        {this.leftIcon}
                    </QIcon>
                ));

            if(this.middlePayload)
                cardTextContent.push((
                    <span class="q-mr-sm">
                        <TranslationContainer context={this} value={this.middlePayload}></TranslationContainer>
                    </span>
                ));
            
            if(this.rightPayload)
                cardTextContent.push((
                    <span class="q-mr-sm">
                        <TranslationContainer context={this} value={this.rightPayload}></TranslationContainer>
                    </span>
                ));

            if(this.rightIcon)
                cardTextContent.push((
                    <QIcon class="q-mr-sm" size="16px">
                        {this.rightIcon}
                    </QIcon>
                ));

            content.push((
                <QCardSection>
                    {cardTextContent}
                </QCardSection>
            ));
        }

        return (
            <QCard
                onMouseenter={this.mouseEnter}
                onMouseleave={this.mouseLeave}
                onClick={this.onClick}
                class={{"q-ma-xs": true, [this.cssClass]: true, [this.activeColorClass]: !!this.activeColorClass}}
                style={{...this.activeColorStyle, 'padding': this.padding + 'px' }} >
                {content}
            </QCard>
        );
    }
});

export default defineComponent({
    name: 'card-list',
    mixins: [BaseComponent],
    components: {
        CardListItem,
        QMenu
    },
    data() {
        return {
            sourceUrlEval: null,
            sourceRawInterpolatedEval: null,
            data: null,
            actAsDropdownEval: null,
            initialSelectedCardEval: null,
            selectCardOnClickEval: null,
            selectedIndex: 0,
            menushowing: false
        }
    },
    async created() {
        switch(this.controlData.SourceType.toLowerCase()) {
            case 'url': {
                this.sourceUrlEval = utils.compile(this, this.controlData.SourceURL);
                await this.getSourceUrl();
                break;
            }
            case 'rawinterpolated':
            case 'raw': {
                this.sourceRawInterpolatedEval = utils.compileObject(this, this.controlData.Source);
                break;
            }
        }

        if(this.controlData.InitialSelectedCardExpression)
            this.initialSelectedCardEval = utils.compile(this, this.controlData.InitialSelectedCardExpression);

        this.renderComplete();
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        totalItems() {
            return (this.source || []).length + 1;
        },
        sourceUrl() {
            try {
                return utils.evaluate(this.sourceUrlEval, this) || [];
            }
            catch(err) {
                return [];
            }
        },
        sourceRawInterpolated(){
            try {
                return utils.evaluateObject(this.sourceRawInterpolatedEval, this) || [];
            }
            catch(err) {
                return [];
            }
        },
        source() {
            switch(this.controlData.SourceType.toLowerCase()) {
                case 'url':
                    return this.data;
                case 'raw': 
                case 'rawinterpolated': return this.sourceRawInterpolated;
                default: return [];
            }
        },
        actAsDropdown() {
            try {
                if(this.actAsDropdownEval === null && this.controlData.ActAsDropdown)
                    this.actAsDropdownEval = utils.compile(this, this.controlData.ActAsDropdown);
                if(this.actAsDropdownEval)
                    return utils.evaluate(this.actAsDropdownEval, this);
                return false;
            }
            catch (e) {
                utils.warn('ActAsDropdown could not evaluate expression: ' + this.controlData.ActAsDropdown + '; ' + e);
                return false;
            }
        },
        selectCardOnClick() {
            try {
                if(this.selectCardOnClickEval === null && this.controlData.SelectCardOnClick)
                    this.selectCardOnClickEval = utils.compile(this, this.controlData.SelectCardOnClick);
                if(this.selectCardOnClickEval)
                    return utils.evaluate(this.selectCardOnClickEval, this);
                return false;
            }
            catch (e) {
                utils.warn('SelectCardOnClick could not evaluate expression: ' + this.controlData.SelectCardOnClick + '; ' + e);
                return false;
            }
        },
        selectedSourceData() {
            if (!this.source || !this.source.length)
                return null;

            if (this.selectedIndex >= this.source.length || this.selectedIndex < 0)
                return this.source[0];

            return this.source[this.selectedIndex];
        }
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
        async getSourceUrl() {
            this.data = await utils.api.get(this.sourceUrl);
        },
        onSelected(index) {
            this.selectedIndex = index
        },
        toggleMenu(e) {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            this.menushowing = !this.menushowing;
        }
    },
    props: {
    },

    render() {
        try {
            if (!this.todisplay)
                return null;

            const source = this.source || [];
            const itemInitialSelectedCardEval = this.actAsDropdown ? null : this.initialSelectedCardEval;
            let items = source.map((sourceData, index) => {
                return (
                    <CardListItem
                        root={this.Root}
                        listCardTemplate={this.controlData.ListCardTemplate}
                        sourceData={sourceData}
                        initialSelectedCardEval={itemInitialSelectedCardEval}
                        selectCardOnClick={this.selectCardOnClick}
                        clickActions={this.controlData.Actions}
                        onSelected={() => this.onSelected(index)}
                    ></CardListItem>
                );
            });

            let content = null;
            if(this.actAsDropdown) {
                content = (
                    <div>
                        <div onClick={this.toggleMenu}>
                            <CardListItem
                                root={this.Root}
                                listCardTemplate={this.controlData.ListCardTemplate}
                                sourceData={this.selectedSourceData}
                            ></CardListItem>
                        </div>
                        <QMenu
                            modelValue={this.menushowing}
                            onUpdate:modelValue={(value) => this.menushowing = value}
                            no-parent-event
                            auto-close
                            fit
                            anchor="bottom left"
                            self="top left"
                        >
                            <div>
                            {items}
                            </div>
                        </QMenu>
                    </div>
                );
            }
            else 
                content = items;
    
            return (
                <div v-show={this.isvisible} style={{...this.sizeStyle, ...utils.resolveStyleHints(this.styleHints, this)}} class={{ 'c-CardList': true, [`c-name-${this.name || 'unnamed'}`]: true }}>
                    {content}
                </div>
            );
        }
        catch(e) {
            utils.error('CardList Render failed', e);
            return <div>CardList Failed to Render {e}</div>;
        }
    }
});